/* @flow */

import React from 'react';
import {connect} from 'react-redux';

import LoadingComponent from 'components/loading';

import DebtorRegisterLeadTab2ViewComponent from './view';

import FinancialInfoForm from './model';

import DebtorService from 'services/DebtorService';
import {handleApiFormResponse, handleFormChange, handleFormValidation} from 'lib/forms';
import loadConstraints from 'lib/validation/loadConstraints';
import NotificationHelper from 'lib/notifications';

type DebtorRegisterLeadTab2ComponentProps = {
  activeCompanyId: number;
  leadId: number;
  onSuccess: () => void;
};

type DebtorRegisterLeadTab2ComponentState = {
  constraints: any;
  errors: Map<string,?string>;
  form: FinancialInfoForm;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
};

class DebtorRegisterLeadTab2Component extends React.Component<DebtorRegisterLeadTab2ComponentProps, DebtorRegisterLeadTab2ComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      constraints: null,
      errors: null,
      form: null,
      formErrors: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {
      const constraints = await loadConstraints('debtor', ['numberOfSuppliers', 'yearlyInvoiceAmount', 'turnOver']);

      this.setState({
        constraints,
        errors: new Map(Object.keys(constraints).map(e => [e, undefined])),
        form: new FinancialInfoForm(),
        isLoading: false,
      });
    } catch (e) {
      console.error(e);
    }
  };

  handleChange = (fieldName: string) => (event) => handleFormChange.call(this, fieldName, event.target.value);
  validateForm = () => handleFormValidation.call(this);

  submitForm = async () => {
    if (!this.validateForm()) return;
    this.setState({formErrors: [], isProcessing: true});

    try {
      const request = this.state.form.toRequest(this.props.activeCompanyId, this.props.leadId);
      await DebtorService.setFinancialInfo(request);
      NotificationHelper.createNotification(NotificationHelper.TYPE_SUCCESS);
      this.props.onSuccess();
    } catch (e) {
      handleApiFormResponse.call(this, e);
    }
  };

  render() {
    if (this.state.isLoading) return (<LoadingComponent />);

    return (
      <DebtorRegisterLeadTab2ViewComponent
        errors={this.state.errors}
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        handleChange={this.handleChange}
        submitForm={this.submitForm}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id
});

export default connect(mapStateToProps)(DebtorRegisterLeadTab2Component);
